/* ═══════════════════════════════════════════
   JoyWell 2026 Revamp — Main JS
   ═══════════════════════════════════════════ */

/* ── CART DRAWER ── */
const CartDrawer = {
  drawer: null,
  overlay: null,
  countEl: null,

  init() {
    this.drawer  = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.countEl = document.querySelector('.js-cart-count');

    document.querySelectorAll('.js-open-cart').forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); this.open(); });
    });

    document.getElementById('cart-close')?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    // Add to cart buttons
    document.querySelectorAll('.js-add-to-cart').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        const qty = parseInt(btn.dataset.qty || 1);
        this.addItem(variantId, qty, btn);
      });
    });

    this.fetchCart();
  },

  open() {
    this.drawer?.classList.add('open');
    this.overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.fetchCart();
  },

  close() {
    this.drawer?.classList.remove('open');
    this.overlay?.classList.remove('open');
    document.body.style.overflow = '';
  },

  async fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.renderCart(cart);
      this.updateCount(cart.item_count);
    } catch(e) { console.error('Cart fetch error', e); }
  },

  async addItem(variantId, qty, btn) {
    const original = btn.innerHTML;
    btn.innerHTML = 'Adding...';
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (res.ok) {
        await this.fetchCart();
        this.open();
      }
    } catch(e) { console.error('Add to cart error', e); }
    btn.innerHTML = original;
    btn.disabled = false;
  },

  async updateQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    this.fetchCart();
  },

  async removeItem(key) {
    await this.updateQty(key, 0);
  },

  updateCount(count) {
    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  renderCart(cart) {
    const itemsEl = document.getElementById('cart-items');
    const footerEl = document.getElementById('cart-footer');
    const emptyEl  = document.getElementById('cart-empty');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      footerEl && (footerEl.style.display = 'none');
      emptyEl  && (emptyEl.style.display  = 'flex');
      return;
    }

    emptyEl  && (emptyEl.style.display  = 'none');
    footerEl && (footerEl.style.display = 'block');

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img class="cart-item__img" src="${item.image}" alt="${item.title}">
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null' ? item.variant_title : ''}</div>
          <div class="cart-item__controls">
            <div class="qty-ctrl">
              <button class="qty-btn" onclick="CartDrawer.updateQty('${item.key}', ${item.quantity - 1})">−</button>
              <span class="qty-num">${item.quantity}</span>
              <button class="qty-btn" onclick="CartDrawer.updateQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <span class="cart-item__price">${this.formatMoney(item.line_price)}</span>
          </div>
          <button class="cart-item__remove" onclick="CartDrawer.removeItem('${item.key}')">Remove</button>
        </div>
      </div>
    `).join('');

    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);
  },

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
};

/* ── ACCORDION ── */
function initAccordions() {
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    // Set initial state
    const isOpen = btn.getAttribute('aria-expanded') === 'true' || btn.dataset.open;
    const content = btn.nextElementSibling;
    if (isOpen) {
      btn.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = '9999px';
    } else {
      content.style.maxHeight = '0';
    }

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      content.style.maxHeight = expanded ? '0' : '9999px';
    });
  });
}

/* ── FAQ ── */
function initFaqs() {
  document.querySelectorAll('.faq-btn').forEach(btn => {
    btn.nextElementSibling.style.maxHeight = '0';
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.nextElementSibling.style.maxHeight = expanded ? '0' : '9999px';
    });
  });
}

/* ── PRODUCT GALLERY ── */
function initGallery() {
  document.querySelectorAll('.js-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.getElementById('main-product-image');
      if (main) {
        main.src = thumb.dataset.src;
        document.querySelectorAll('.js-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });
}

/* ── QTY SELECTOR ── */
function initQty() {
  document.querySelectorAll('.js-qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.js-qty-input');
      if (input) input.value = Math.max(1, parseInt(input.value) - 1);
    });
  });
  document.querySelectorAll('.js-qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.js-qty-input');
      if (input) input.value = parseInt(input.value) + 1;
    });
  });
}

/* ── MOBILE NAV ── */
function initMobileNav() {
  const toggle = document.getElementById('nav-toggle');
  const menu   = document.getElementById('mobile-menu');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', () => {
    const isOpen = menu.style.display === 'flex';
    menu.style.display = isOpen ? 'none' : 'flex';
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
}


/* ── RECHARGE SUBSCRIBE & SAVE ── */
function rechargeSubscribe(btn) {
  var variantId = btn.getAttribute('data-variant-id');
  var planId = btn.getAttribute('data-plan-id');
  var original = btn.innerHTML;
  btn.innerHTML = 'Adding...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      selling_plan: planId
    })
  }).then(function(res) {
    if (res.ok) {
      CartDrawer.fetchCart();
      CartDrawer.open();
    } else {
      res.json().then(function(data) {
        alert(data.description || 'Could not add subscription. Please try again.');
      });
    }
  }).catch(function(e) {
    console.error('Recharge subscribe error:', e);
  }).finally(function() {
    btn.innerHTML = original;
    btn.disabled = false;
  });
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
  initAccordions();
  initFaqs();
  initGallery();
  initQty();
  initMobileNav();
});

// Expose globally
window.CartDrawer = CartDrawer;
